import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PenBox } from "lucide-react";
import { getDoc, doc, onSnapshot } from "firebase/firestore";
import { db, auth } from "../config/firebase";
import { onAuthStateChanged } from "firebase/auth";

const WRITERS_DOC_ID = "06uC8j9NfvRwSOXrKhXP"; // Replace with your actual document ID

const BlogEditorButton = () => {
  const [isWriter, setIsWriter] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Listen for auth state changes
    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        console.log("No user is signed in.");
        setIsWriter(false);
        setLoading(false);
        return;
      }

      try {
        // Set up real-time listener for writers document
        const writersRef = doc(db, "bolg_writers", WRITERS_DOC_ID);
        const unsubscribeDoc = onSnapshot(writersRef, (docSnap) => {
          if (docSnap.exists()) {
            const writers = docSnap.data().writers || [];
            console.log("Current User UID:", user.uid);
            console.log("Writers List:", writers);

            const hasAccess = writers.includes(user.uid);
            console.log(hasAccess ? "✅ User has writer access" : "❌ User does NOT have writer access");
            setIsWriter(hasAccess);
          } else {
            console.log("Writers document does not exist");
            setIsWriter(false);
          }
          setLoading(false);
        }, (error) => {
          console.error("Error fetching writers:", error);
          setIsWriter(false);
          setLoading(false);
        });

        // Clean up the document listener when auth state changes or component unmounts
        return () => unsubscribeDoc();
      } catch (error) {
        console.error("Error setting up writers listener:", error);
        setIsWriter(false);
        setLoading(false);
      }
    });

    // Clean up the auth listener when component unmounts
    return () => unsubscribeAuth();
  }, []);

  if (loading) {
    return null;
  }

  if (!isWriter) {
    return null;
  }

  return (
    <Link
      to="/blog-editor"
      className="inline-flex items-center gap-2 bg-gray-600 text-white font-medium py-2.5 px-5 rounded-xl shadow hover:bg-blue-700 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-400"
      title="Write a new blog post"
    >
      <PenBox className="w-5 h-5" />
      <span className="hidden sm:inline">Write Blog</span>
    </Link>
  );
};

export default BlogEditorButton;
